<div class="mb-2 flex flex-wrap items-center gap-2">
  <span
    class="inline-flex items-center gap-1 rounded-full border border-primary text-primary px-3 py-1 body-2"
    [matTooltip]="membersLabel"
  >
    <mat-icon style="font-size: 18px; width: 18px; height: 18px">groups</mat-icon>
    {{ team.name }}
  </span>
  <team-action-mock-new [show]="settings.showNew"></team-action-mock-new>
</div>
<p
  class="m-0 mb-2 caption text-secondary"
  matTooltip="Équipe désignée en plus des personnes du champ. Maquette : données fictives."
>
  Équipes proposées : celles de {{ support.name }}
</p>
